/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { InputConstraintType } from "./InputConstraintType";
export const InputConstraint = core.serialization.object({
    type: InputConstraintType,
});
